import { OffersMigrationAlert } from '@client/new/components/OffersMigrationAlert';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './ProgramMigrationAlert.css';

type ProgramMigrationAlertProps = {
  visible: boolean;
};

export const ProgramMigrationAlert = ({
  visible,
}: ProgramMigrationAlertProps) => (
  <OffersMigrationAlert
    visible={visible}
    dismissKey="programMigrationAlertDismissed"
    wrapperClassName={styles.spacing}
    body={
      <Typography
        variant="body"
        size="medium"
        fontWeight="normal"
        color="N-100"
      >
        Head to Offers to adjust Landing pages, pricing, grab links, and more.
      </Typography>
    }
  />
);
